import React from 'react';
import { Skeleton } from '../common';

const WeatherSkeleton = () => {
  return (
    <div className="space-y-4">
      {/* Current Conditions Skeleton */}
      <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur rounded-xl shadow-lg p-5 border border-orange-100 dark:border-gray-700">
        <Skeleton width={160} height={24} className="mb-4" />
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {[1, 2, 3, 4, 5, 6].map(i => (
            <div key={i} className="text-center">
              <Skeleton variant="circular" width={48} height={48} className="mx-auto mb-2" />
              <Skeleton width={60} height={20} className="mx-auto mb-1" />
              <Skeleton width={80} height={16} className="mx-auto" />
            </div>
          ))}
        </div>
      </div>

      {/* Beach Flag Skeleton */}
      <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur rounded-xl shadow-lg p-5 border border-orange-100 dark:border-gray-700">
        <div className="flex justify-between items-center mb-4">
          <Skeleton width={140} height={24} />
          <Skeleton width={80} height={20} />
        </div>
        <div className="text-center">
          <Skeleton variant="circular" width={80} height={80} className="mx-auto mb-3" />
          <Skeleton width={200} height={24} className="mx-auto mb-2" />
          <Skeleton width={250} height={16} className="mx-auto" />
        </div>
      </div>

      {/* Hourly Forecast Skeleton */}
      <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur rounded-xl shadow-lg p-5 border border-orange-100 dark:border-gray-700">
        <Skeleton width={140} height={24} className="mb-4" />
        <div className="flex gap-3 overflow-x-auto pb-2">
          {[1, 2, 3, 4, 5, 6].map(i => (
            <div key={i} className="flex-shrink-0 bg-gray-50 dark:bg-gray-700/50 rounded-lg p-3" style={{ minWidth: '80px' }}>
              <Skeleton width={40} height={12} className="mx-auto mb-2" />
              <Skeleton variant="circular" width={32} height={32} className="mx-auto mb-2" />
              <Skeleton width={30} height={20} className="mx-auto" />
            </div>
          ))}
        </div>
      </div>

      {/* Daily Forecast Skeleton */}
      <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur rounded-xl shadow-lg p-5 border border-orange-100 dark:border-gray-700">
        <Skeleton width={120} height={24} className="mb-4" />
        <div className="space-y-3">
          {[1, 2, 3].map(i => (
            <div key={i} className="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <div className="flex items-center justify-between">
                <div>
                  <Skeleton width={80} height={20} className="mb-1" />
                  <Skeleton width={60} height={16} />
                </div>
                <div className="flex items-center gap-3">
                  <Skeleton variant="circular" width={40} height={40} />
                  <div>
                    <Skeleton width={30} height={20} className="mb-1" />
                    <Skeleton width={30} height={16} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WeatherSkeleton;